
const normalizeBaseUrl = (url) => {
    if (!url) return '';
    return url.replace(/\/shypvdriverapp\/?$/, '').replace(/\/$/, '');
};

export const getDriverApiBaseUrl = () => {
    const driverApiUrl = process.env.REACT_APP_DRIVER_API_URL || process.env.REACT_APP_API_URL;
    if (driverApiUrl) {
        return normalizeBaseUrl(driverApiUrl);
    }
    console.warn('Driver API URL not set. Defaulting to local driver API.');
    return 'http://localhost:5566';
};

// CRM API base URL - always points to shypv CRM backend (for partner data, etc.)
export const getCrmApiBaseUrl = () => {
    const crmApiUrl = process.env.REACT_APP_CRM_API_URL;
    if (crmApiUrl) {
        return normalizeBaseUrl(crmApiUrl);
    }

    const env = process.env.REACT_APP_ENV;
    if (env === 'production') {
        return 'https://api.shypv.com';
    }

    if (env === 'staging') {
        return 'https://staging-api.shypv.com';
    }

    // Default to local CRM API for local environment
    return 'http://localhost:8081';
};

// Backward-compatible alias used across legacy code.
// Most legacy consumers of getApiBaseUrl are CRM partner endpoints.
export const getApiBaseUrl = () => getCrmApiBaseUrl();

export const getShypvBaseUrl = () => {
    const env = process.env.REACT_APP_ENV;
    if (env === 'production') {
        return "https://business-agent.shypv.com";
    }
    return "https://business-agent-stage.shypv.com";
};

/**
 * Generate short unique reference for orders
 * Format: {prefix}-YYMMDD-XXXX
 * @param {string} prefix - "M" for Medical, "N" for Normal orders
 * @param {number} index - Index for additional uniqueness
 * @returns {string} - e.g., "M-260121-A7K2" or "N-260121-B3K9"
 */
export const generateShortRef = (prefix = "M", index = 0) => {
    const now = new Date();
    const yy = String(now.getFullYear()).slice(-2);
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const dateStr = `${yy}${mm}${dd}`;
    
    // Generate 4-char alphanumeric code (A-Z, 0-9)
    // Exclude confusing chars: I, O, 0, 1
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let code = "";
    const timestamp = now.getTime();
    const seed = timestamp + index;
    
    for (let i = 0; i < 4; i++) {
        const randomIndex = (seed + Math.floor(Math.random() * 1000) + i * 7) % chars.length;
        code += chars[randomIndex];
    }
    
    return `${prefix}-${dateStr}-${code}`;
};